import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  padding: 20px;
  background: #fff;
  gap: 10px;
  -webkit-overflow-scrolling: touch;
`;
